import { useEffect, useState } from 'react';
import { useThrottledCallback } from 'use-debounce';

import { htmlToSlate, slateToText } from 'src/components/RichSlate';
import { countChars, countWords } from 'src/lib/string';

const COUNTING_INTERVAL = 500;

const countValues = (htmlString) => {
  const plainText = slateToText(htmlToSlate(htmlString)).trim();
  return {
    characters: countChars(plainText),
    words: countWords(plainText),
  };
};

export const useHtmlCounters = (htmlString) => {
  const [counters, setCounters] = useState(() => countValues(htmlString));

  const updateCounters = useThrottledCallback((value) => {
    setCounters(countValues(value));
  }, COUNTING_INTERVAL);

  useEffect(() => {
    updateCounters(htmlString);
  }, [updateCounters, htmlString]);

  return counters;
};
